import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getIndustryOfficeInsightIndustry = [
  {
    route: 'Dashboard',
    text: 'Mon espace client',
    href: '/backoffice/insight/dashboard-industry',
    menuHeader: true,
    position: 10,
  },
  {
    route: 'Survey',
    text: 'Créer une enquête',
    href: '/backoffice/insight/survey-industry',
    menuHeader: true,
    position: 20,
  },
  {
    route: 'Credit',
    text: 'Mes crédits',
    href: '/backoffice/insight/my-credits',
    menuHeader: true,
    position: 30,
  },
  {
    route: 'SurveyAdd',
    text: 'Ajouter  un questionnaire',
    href: '/backoffice/insight/survey/add-survey',
  },
  {
    route: 'SurveyEdit',
    text: 'Editer  un questionnaire',
    href: '/backoffice/insight/survey/edit-survey/[surveyId]',
  },
  {
    route: 'SurveyExport',
    text: 'Export des questionnaires',
    href: '/backoffice/insight/survey/export-survey',
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  // Acces = la « Fonction » Prestataire PMI DIY portee par le user (role ci-dessous).
  // Pas de flag d'activation supplementaire porte par la company.
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_PMI_DIY],
}))

export default getIndustryOfficeInsightIndustry
